import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
@Directive({
  selector: '[inputDecimal]'
})
export class InputDecimal implements OnInit {
  public regex: RegExp;
  public regexNumbers = '^[0-9]*$';
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', ' ', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  @Input() decimals: string;
  @Input() onlyNumbers: boolean;
  @Input() currency: boolean;
  constructor(private el: ElementRef) {
    
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    if(this.onlyNumbers){
      let valor: string = this.el.nativeElement.value + event.key;
      let regEx =  new RegExp(this.regexNumbers);    
      if(regEx.test(valor))
        return;
      else
        event.preventDefault();
    }
    
    let current: string = this.el.nativeElement.value;
    /*
    if(this.currency){
      var amountFormatted = this.formatAsCurrency(current); //$2,500.00
      amountFormatted = amountFormatted.substr(1, amountFormatted.length);
      if(amountFormatted.match(this.regex)){
        console.log(amountFormatted);
      } //2,500
    }*/
    const position = this.el.nativeElement.value.length;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  ngOnInit() {
    //this.regex = new RegExp("^(?!0\\.00)\\d{1,3}(,\\d{3})*(\\.\\d\\d)?$");
    this.regex = new RegExp("^\\d*\\.?\\d{0,"+this.decimals+"}$", "g");
  }

  formatAsCurrency(amount){
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: parseInt(this.decimals),
      maximumFractionDigits: parseInt(this.decimals),
    });
    return formatter.format(parseFloat(amount)).toString();
  }
}